import React, { InputHTMLAttributes } from 'react';
import '../form.scss';
import { colours } from 'utils/constants';

interface GeneratorInputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  methods?: any;
  wrapperClass?: string;
  className?: string;
  validate?: any;
  excluded?: any;
  min: number;
  max: number;
  disabled?: boolean;
}

export default function GeneratorInput({
  methods,
  validate,
  name,
  label,
  wrapperClass,
  min,
  max,
  excluded,
  disabled = false,
  ...rest
}: GeneratorInputProps) {
  const {
    register,
    setValue,
    setError,
    clearErrors,
    formState: { errors }
  } = methods;

  // Common disabled styles
  const commonDisabledStyle = {
    cursor: 'not-allowed',
    opacity: 1
  };

  // Inline styles for the disabled button state
  const disabledButtonStyle = disabled
    ? {
        ...commonDisabledStyle,
        backgroundColor: colours.disabledButton,
        color: colours.disabledButtonText
      }
    : {};

  // Inline styles for the disabled input state
  const disabledInputStyle = disabled
    ? {
        ...commonDisabledStyle,
        color: colours.disabledButtonText
      }
    : {};

  const handleGenerate = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    const generated = Math.round(Math.random() * (max - min)) + min;
    if (excluded.includes(generated)) {
      setError(name, {
        type: 'custom',
        message: 'Already used please generate again / Out of cards'
      });
    } else {
      clearErrors(name);
      setValue(name, generated);
    }
  };

  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral9 font-semibold" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="flex">
        <input
          className="input mr-1.5 w-4/5"
          aria-invalid={errors ? 'true' : 'false'}
          disabled={disabled}
          style={disabledInputStyle}
          {...register(name, { validate: validate })}
          {...rest}
        />
        <button
          type="button"
          className="primary-btn p-2"
          onClick={handleGenerate}
          disabled={disabled}
          style={disabledButtonStyle}
        >
          Generate
        </button>
      </div>
      {errors[name] && (
        <span className="error" role="alert">
          {errors[name].message}
        </span>
      )}
    </div>
  );
}
